export type SiteConfig = typeof siteConfig;

export const siteConfig = {
  name: "CryptoTX - The Smart way to terminate USDT transactions in local currency!",
  author: "FaireNation",
  description:
    "Converting USDT to local currency on the go for your business and personal needs: A Simple, Swift, and Secure Process.",
  keywords: [
    "crypto",
    "transfer",
    "money transfer",
    "cryptocurrency",
    "fairenation",
    "Crypto Transaction Platform",
    "CryptoTX",
  ],
  navItems: [
    {
      label: "Home",
      href: "/",
    },
    {
      label: "Currencies",
      href: "/currencies",
    },
  ],
  navMenuItems: [
    {
      label: "Home",
      href: "/",
    },
    {
      label: "Currencies",
      href: "/currencies",
    },
    {
      label: "Privacy Policy",
      href: "/privacy-policy",
    },
    {
      label: "Terms & Conditions",
      href: "/terms",
    },
  ],
  links: {
    login: "https://app.fncryptotx.com/login",
    register: "https://app.fncryptotx.com/register",
    transfer: "https://app.fncryptotx.com/transfer",
  },
};
